export class Contact {
  phone?: string;
  email?: string;
  optInConsent?: boolean;

  constructor(phone?: string, email?: string, optin?: boolean) {
    this.phone = phone;
    this.email = email;
    this.optInConsent = optin;
  }

  isValid() {
    return this.phone != null || this.email != null || this.optInConsent != null;
  }
}
